// extracted by mini-css-extract-plugin
module.exports = {"container":"YC+euyl0syeSrfUNrSIDqg==","active":"_9cD1Ctdnto3hOAk7+4NAlQ==","label":"_0IXdts8oZqcmb5qf1Op55Q=="};